import { GlLoadingIcon, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { joinPaths, buildURLwithRefType } from '~/lib/utils/url_utility';
export default {
    name: 'ParentRow',
    components: {
        GlLoadingIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    inject: [
        'refType'
    ],
    props: {
        commitRef: {
            type: String,
            required: true
        },
        path: {
            type: String,
            required: true
        },
        loadingPath: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        parentPath () {
            const splitArray = this.path.split('/');
            splitArray.pop();
            return splitArray.map((p)=>encodeURIComponent(p)).join('/');
        },
        parentRoute () {
            // eslint-disable-next-line @gitlab/no-hardcoded-urls -- This is a Vue router route defined in app/assets/javascripts/repository/router.js, acceptable in this case
            const path = joinPaths('/-/tree', this.commitRef, this.parentPath);
            return buildURLwithRefType({
                path,
                refType: this.refType
            });
        }
    },
    methods: {
        clickRow () {
            this.$router.push(this.parentRoute);
        }
    }
};
